import Vue from 'vue'

const state = Vue.observable({
    loader: false,
    unseendocuments: 0,
    unseendocumentsgrouped: {},
    enquiriesLeft: null,
    upgrade: null,
    showError: false,
    version: null,

    validationErrors: null,
    showValidation: false,
    
    // Queue of snacks
    snacks: [],
    // The active snack
    snack: null,
    announcements: [],
    currentAnnouncement: null,
    header: '',
    showConfirm: false,
    confirmRes: null
})

var busy = false;
var key = 0
var timer;
var errorTimer;

function processNext() {
    if (busy) {
        return
    }
    state.snack = null
    if (state.snacks.length > 0) {
        busy = true
        state.snack = state.snacks.shift()
        timer = setTimeout(() => {
            busy = false
            processNext()
        }, state.snack.keepalive)
    }
}

export default {
    state,
    dismiss() {
        clearInterval(timer)
        busy = false
        processNext()
    },
    showError() {
        if (errorTimer) {
            clearTimeout(errorTimer)
        }
        this.state.showError = true
        errorTimer = setTimeout(() => this.hideError(), 12000)
    },
    hideError() {
        clearTimeout(errorTimer)
        this.state.showError = false
    },
    showAnnouncement(announcement) {
        this.state.currentAnnouncement = announcement
        if (announcement.seen) {
            return
        }
        // Set seen true
        this.state.announcements = this.state.announcements.map(a => {
            if (a.id === announcement.id) {
                a.seen = true
            }
            return a
        })
    },
    addAnnouncement(announcement) {
        // Check if exists on id, if exist set seen false else add
        let exists = this.state.announcements.find(a => a.id === announcement.id)
        if (exists) {
            this.state.announcements = this.state.announcements.map(a => {
                if (a.id === announcement.id) {
                    a = announcement
                }
                return a
            })
        } else {
            this.state.announcements.push(announcement)
        }
    },
    // info, error, warning, success
    showSnack(text, type = "info", keepalive = 12000) {
        var snack = {
            text,
            keepalive,
            type,
            key: (++key % 100)
        }
        state.snacks.push(snack)
        this.dismiss()
    },
    showLoader() {
        state.loader = true
    },
    hideLoader() {
        state.loader = false
    },
    showValidationError(errors) {
        state.validationErrors = errors; 
        state.showValidation = true;
    },
    confirm(text = 'Are you sure?') {
        state.header = text
        state.showConfirm = true
        
        return new Promise((res, rej) => {
            state.confirmRes = res
        });
    },
    confirmState(yesno) {
        if (state.confirmRes) {
            state.confirmRes(yesno)
            state.showConfirm = false
        }
    },
    setUnseendocuments(count) {
        state.unseendocuments = count
    },
    setVersion(version) {
        state.version = version
    },
    setUnseendocumentsGrouped(data) {
        state.unseendocumentsgrouped = data
    },
    setEnquiriesLeft(count) {
        state.enquiriesLeft = count
    },
    scheduleUpgrade(seconds) {
        state.upgrade = {
            show: true,
            seconds: seconds
        }
        // start timer
        window.setInterval(() => {
            state.upgrade.seconds--
            if (state.upgrade.seconds <= 0) {
                window.location.reload()
            }
        }, 1000)
    }
}